var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-head"},[_c('div',{staticClass:"leftTitle",style:({paddingLeft:_vm.isPaddingLeft == true?'10px':''})},[_vm._v(_vm._s(_vm.title))]),(_vm.isShowRightText)?_c('div',{staticClass:"rightTitle",on:{"click":_vm.goList}},[_vm._v("更多")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }